import * as cx from 'classnames';
import * as React from 'react';
import * as Styles from './SectionHeader.scss';

interface IOwnProps {
  title: string;
  accent?: boolean;
  light?: boolean;
}

const SectionHeader: React.SFC<IOwnProps> = ({ title, accent, light }) => {
  const sectionHeaderClassNames = cx({
    [Styles.header]: true,
    [Styles.accent]: accent,
    [Styles.light]: light,
  });

  return (
    <div className={sectionHeaderClassNames}>
      <h1 className={Styles.title}>{title}</h1>
    </div>
  );
};

export default SectionHeader;



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/presentational/SectionHeader/SectionHeader.tsx